import { render, staticRenderFns } from "./InstalledAppsTable.vue?vue&type=template&id=540e06c6&scoped=true&"
import script from "./InstalledAppsTable.vue?vue&type=script&lang=js&"
export * from "./InstalledAppsTable.vue?vue&type=script&lang=js&"
import style0 from "./InstalledAppsTable.vue?vue&type=style&index=0&id=540e06c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e06c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540e06c6')) {
      api.createRecord('540e06c6', component.options)
    } else {
      api.reload('540e06c6', component.options)
    }
    module.hot.accept("./InstalledAppsTable.vue?vue&type=template&id=540e06c6&scoped=true&", function () {
      api.rerender('540e06c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Installer/InstalledAppsTable.vue"
export default component.exports